
import { api } from '../core';
import { AccessToken } from '../../types';
import { MOCK_TOKENS } from '../mockData';

const mapToUI = (apiToken: any): AccessToken => {
    return {
        id: apiToken.id,
        name: apiToken.name,
        token: apiToken.token,
        type: apiToken.type as any,
        createdAt: new Date(apiToken.createdAt).getTime(),
        expiresAt: apiToken.expiresAt ? new Date(apiToken.expiresAt).getTime() : null,
        status: apiToken.status as any
    };
};

export const AccessService = {
  getTokens: async (): Promise<AccessToken[]> => {
    return api.execute<AccessToken[]>(
      '/api/V1/AccessToken/GetAllByLanguage',
      async () => {
        const saved = localStorage.getItem('lahja_tokens');
        return saved ? JSON.parse(saved) : MOCK_TOKENS;
      },
      { mockDelay: 400 }
    ).then(res => {
        if (Array.isArray(res) && res.length > 0 && 'token' in res[0]) {
            return res.map(mapToUI);
        }
        return res as AccessToken[];
    });
  },

  createToken: async (name: string, type: AccessToken['type'], durationDays: number): Promise<AccessToken> => {
    const mockToken: AccessToken = {
        id: Date.now().toString(),
        name,
        token: `lahja_sk_${type}_${Math.random().toString(36).substring(2, 18)}`,
        type,
        createdAt: Date.now(),
        expiresAt: durationDays === -1 ? null : Date.now() + (durationDays * 24 * 60 * 60 * 1000),
        status: 'active'
    };

    return api.execute<AccessToken>(
      '/api/V1/AccessToken/Create',
      mockToken,
      { 
          method: 'POST', 
          body: { 
              name, 
              type, 
              // Sending ISO date for expiration
              expiresAt: durationDays === -1 ? null : new Date(Date.now() + (durationDays * 24 * 60 * 60 * 1000)).toISOString() 
          }
      }
    ).then(res => ('token' in (res as any) ? mapToUI(res) : res));
  },

  revokeToken: async (id: string): Promise<void> => {
    return api.execute<void>(
      `/api/V1/AccessToken/Delete/${id}`,
      undefined,
      { method: 'DELETE' }
    );
  }
};
